export default "__VITE_ASSET__DAYWee$C__"